<template>
  <h1>test</h1>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'Theme8Test',
  mixins: [ComponentMixin],
});
</script>
